import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import GlobalFooter from './GlobalFooter';

function AccountIdentification() {
  const record = JSON.parse(localStorage.getItem('auth'));
  const countryCode = localStorage.getItem('countryCode');

  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const { state } = useLocation();

  const { payload } = state;
  const institutionId = payload?.institutionId || '';

  useEffect(() => {
    if (!payload) return navigate('/pages/institutions');
  }, []);

  const psuRequiredInstitutions = new Set([
    'alpenbank',
    'dell-alto-adige',
    'alta-pusteria',
    'alta-venosta',
    'bassa-atseina',
    'bassa-venosta',
    'campo-di-trens',
    'castelrotto-ortisei',
    'della-val-passiria',
    'della-valle-isarco',
    'di-brunico',
    'di-dobbiaco',
    'di-funes',
    'di-lagundo',
    'lasa',
    'di-marlengo',
    'di-merano',
    'di-nova-ponente-aldino',
    'di-parcines',
    'di-scena',
    'di-tesimo',
    'di-villabassa',
    'etschtal',
    'gherdeina',
    'lances',
    'lana',
    'monguelfo-casiestesido',
    'oltradige',
    'prato-tubre',
    'schlern-rosengarten',
    'silandro',
    'tirolo',
    'tures-aurina',
    'ultimo-pancrazio-lauregno',
    'val-badia',
    'val-sarentino',
    'vandoies',
    'wipptal',
    'di-bolzano',
    'di-salorno',
    'deutschebank-pfb_de',
    'handelsbankenbusiness_uk',
    'intesa_sanpaolo',
    'postbank',
    'smbc',
  ]);

  const shouldCollectPSUId =
    (countryCode === 'IT' || countryCode === 'DE') &&
    psuRequiredInstitutions.has(institutionId);

  const onSubmit = async (data) => {
    setIsLoading(true);

    let finalPayload = {
      ...payload,
      fullName: data.fullName,
      iban: data.iban,
    };

    if (shouldCollectPSUId) {
      finalPayload.psuId = data.psuId;
    }

    console.log('fainalPayload', finalPayload);
    try {
      const url =
        'https://1mgy6330f9.execute-api.us-east-2.amazonaws.com/production/global-payment/europe/v2/initiate-payment-auth-others-2';
      console.log('finalPayload: ', finalPayload);
      const res = await axios.post(url, finalPayload);
      console.log('result: ', res.data);
      const { authorisationUrl } = res.data.data.data;
      setIsLoading(false);

      if (authorisationUrl) {
        window.location.href = authorisationUrl;
        return;
      } else {
        toast('External link not available');
        return;
      }
    } catch (err) {
      setIsLoading(false);
      console.error(err);
      const errorMessage =
        err?.response?.data?.message ||
        'An error has occurred, please try again.';
      toast.error(errorMessage);
    }
  };

  const handleClick = () => {
    navigate('/pages/institutions');
  };

  const handleClose = () => {
    navigate('/pages/payment-credential');
  };

  return (
    <div className="global_layout">
      <div className="global_container">
        <div className="top_bar">
          <img
            src="/images/global/arrow-left.svg"
            alt=""
            onClick={handleClick}
          />
          <img
            src="/images/global/close.svg"
            alt=""
            style={{ marginLeft: 'auto' }}
            onClick={handleClose}
          />
        </div>

        <div className="global_content">
          <p className="glob_title">Payment Information</p>
          <p className="glob_desc">
            Your data is encrypted and your details will not be accessible to
            Superwallet
          </p>

          <form
            className="glob_form"
            onSubmit={handleSubmit(onSubmit)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              marginTop: '20px',
            }}
          >
            <div className="input_group">
              <label className="input_lbl" htmlFor="fullName">
                Full Name
              </label>
              <input
                placeholder="Full Name"
                className="input_field"
                {...register('fullName', {
                  required: 'Full Name is required.',
                })}
              />
              {errors.fullName && (
                <p className="error_msg">{errors.fullName.message}</p>
              )}
            </div>

            <div className="input_group">
              <label className="input_lbl" htmlFor="iban">
                IBAN
              </label>
              <input
                placeholder="IBAN"
                className="input_field"
                {...register('iban', { required: 'IBAN is required.' })}
              />
              {errors.iban && (
                <p className="error_msg">{errors.iban.message}</p>
              )}
            </div>

            {/* PSU ID Field  */}
            {shouldCollectPSUId && (
              <div className="input_group">
                <label className="input_lbl" htmlFor="psuId">
                  PSU ID
                </label>
                <input
                  placeholder="PSU ID"
                  className="input_field"
                  {...register('psuId', {
                    required: 'PSU ID is required for Italy.',
                  })}
                />
                {errors.psuId && (
                  <p className="error_msg">{errors.psuId.message}</p>
                )}
              </div>
            )}

            <button
              type="submit"
              disabled={isLoading}
              className={`${isLoading ? 'unactive' : 'globalBtn'}`}
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
              }}
            >
              {isLoading ? (
                <BeatLoader color="#FFF" />
              ) : (
                <>
                  Proceed <img src="/images/global/activeArrow.svg" alt="" />
                </>
              )}
            </button>
          </form>
        </div>
      </div>
      {!record?.total_whitelabelling && <GlobalFooter />}
    </div>
  );
}

export default AccountIdentification;
